import { ProcessoPlanejamentoService } from './../../../services/processo-planejamento.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Equipamento, TiposCombustivelEquipamento, TiposMedidorEquipamento } from 'src/app/classes/Equipamento';
import { EquipamentoService } from 'src/app/services/equipamento.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import Swal from 'sweetalert2';
import { GrupoEquipamento } from 'src/app/classes/GrupoEquipamento';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { GrupoEquipamentoService } from 'src/app/services/grupo-equipamento.service';
import { environment } from 'src/environments/environment';
import { ProcessoPlanejamento } from 'src/app/classes/ProcessoPlanejamento';
import { UtilsService } from 'src/app/utils/utils.service';
import { Location } from '@angular/common';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import * as moment from 'moment';

@Component({
  selector: 'app-equipamento',
  templateUrl: './equipamento.component.html',
  styleUrls: ['./equipamento.component.scss']
})
export class EquipamentoComponent implements OnInit {

  @ViewChild("gridEquipamentos", { static: false })
  gridEquipamentos: SyncGridComponent;

  onFilterActionBegin(args: any): void {
    // Intercepta o evento de filtro para ajustar o operador "igual a" para datas
    if (args.requestType === 'filtering') {
      // Verifica se há filtros sendo aplicados
      if (args.filterModel && args.filterModel.DataAlteracaoFilter) {
        const filterModel = args.filterModel.DataAlteracaoFilter;
        
        // Verifica se o operador é "equal" (igual a)
        if (filterModel.operator === 'equal' && filterModel.value) {
          // Converte "igual a" para um range do início ao fim do dia
          const filterDate = new Date(filterModel.value);
          if (!isNaN(filterDate.getTime())) {
            // Data inicial: início do dia (00:00:00)
            const startDate = new Date(filterDate);
            startDate.setHours(0, 0, 0, 0);
            
            // Data final: fim do dia (23:59:59.999)
            const endDate = new Date(filterDate);
            endDate.setHours(23, 59, 59, 999);
            
            // Altera o filtro para usar "between" ao invés de "equal"
            filterModel.operator = 'between';
            filterModel.value = startDate;
            filterModel.value2 = endDate;
          }
        }
      }
      
      // Também verifica currentFilterObject (estrutura alternativa)
      if (args.currentFilterObject) {
        const filterObject = args.currentFilterObject;
        
        if (filterObject.field === 'DataAlteracaoFilter' && filterObject.operator === 'equal' && filterObject.value) {
          const filterDate = new Date(filterObject.value);
          if (!isNaN(filterDate.getTime())) {
            const startDate = new Date(filterDate);
            startDate.setHours(0, 0, 0, 0);
            
            const endDate = new Date(filterDate);
            endDate.setHours(23, 59, 59, 999);
            
            filterObject.operator = 'between';
            filterObject.value = startDate;
            filterObject.value2 = endDate;
          }
        }
      }
    }
  }

  equipamentos: Equipamento[];
  auxEquipamentos: Equipamento[];
  equipamento: Equipamento;
  id: number;
  inserindo: boolean = false;
  carregando: boolean = false;
  processosPlanejamento: ProcessoPlanejamento[];
  processosPlanejamentoSelecionados: number[] = [];
  showAbastecimento: boolean = false;
  listaTipoMedidor = TiposMedidorEquipamento;
  listaTipoCombustivel = TiposCombustivelEquipamento;

  form: any;
  public isSubmit: boolean;
  textoBusca: string = "";

  grupoEquipamentos: GrupoEquipamento[];

  baseIcone: string = environment.baseApiURL + '/Assets/Icones/';
  gridHeight: string = '79vh';
  equipamentoColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false
  removendo: boolean = false
  duplicando: boolean = false
  inativando: boolean = false
  int32MaxValue = 2147483647;

  gridPageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 50],
    pageSize: 20, // padrão alterado para 20
    pageCount: 4
  };
  constructor(private equipamentosService: EquipamentoService,
    private grupoEquipamentoService: GrupoEquipamentoService,
    private route: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private processoPlanejamentoService: ProcessoPlanejamentoService,
    private utils: UtilsService,
    private location: Location) {
    if (this.router.url.search("inserir") > 0) {
      if (!this.utils.verificarPermissaoUsuario('IncluirEquipamento')) {
        this.location.back();
      }
    }
    this.route.params.subscribe(res => {
      this.id = res.id;
      if (this.id > 0)
        if (!this.utils.verificarPermissaoUsuario('EditarEquipamento')) {
          this.location.back();
        }
    });
  }

  ngOnInit() {
    this.inserindo = this.router.url.search("inserir") > 0;
    this.equipamento = new Equipamento();

    this.grupoEquipamentoService.getGrupoEquipamentos().subscribe(ret => {
      this.grupoEquipamentos = ret,
        err => {
          this.utils.getErro(err);
        };
    });

    this.processoPlanejamentoService.getProcessosPlanejamento().subscribe(res => {
      this.processosPlanejamento = res,
        err => {
          this.utils.getErro(err);
        };
    });

    if (this.id > 0)
      this.selecionarEquipamento();
    else
      this.listarEquipamentos();
  }

  ajustarTamanhoGrid(): void {
    const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
    const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
    const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
    const pagination = document.querySelector('div.e-gridpager.e-control.e-pager.e-lib') as HTMLElement
    const title = document.querySelector('app-equipamento h5.titulo') as HTMLElement
    const altura = window.innerHeight - navbar.offsetHeight - groupdroparea.offsetHeight - toolbar.offsetHeight - title.offsetHeight - pagination.offsetHeight - 70
    this.gridHeight = `${altura}px`
  }

  configurarGrid(): void {
    this.equipamentoColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false },
      {
        field: "GrupoEquipamentoDesc",
        headerText: "Grupo de Equipamento",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Marca",
        headerText: "Marca",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Descricao",
        headerText: "Modelo",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Tag",
        headerText: "Tag",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Potencia",
        headerText: "Potência (CV)",
        type: "string",
        allowSorting: true,
        visible: false,
      },
      {
        field: "Chassi",
        headerText: "Chassi",
        type: "string",
        allowSorting: true,
        visible: false,
      },
      {
        field: "NSerie",
        headerText: "Nº de Série",
        type: "string",
        allowSorting: true,
        visible: false,
      },
      {
        field: "Placa",
        headerText: "Placa",
        type: "string",
        allowSorting: true,
        visible: false,
      },
      {
        field: "LarguraTrabalho",
        headerText: "Larg. de Trabalho(m)",
        type: "number",
        allowSorting: true,
        visible: false,
      },
      {
        field: "DoseTanque",
        headerText: "Capac. Carga de Insumos(L)",
        type: "number",
        allowSorting: true,
      },
      {
        field: "CapacidadeCombustivel",
        headerText: "Capac. Tanque de Combustível",
        type: "number",
        allowSorting: true,
        visible: false,
      },
      {
        field: "Consumo",
        headerText: "Consumo Médio (L/h)",
        type: "number",
        allowSorting: true,
      },
      {
        field: "",
        headerText: "Tipo de Medidor",
        type: "string",
        allowSorting: true,
        visible: false,
        valueAccessor: (_field: string, _data: any): any => {
          return this.listaTipoMedidor.find(item => item.value === _data.TipoMedidor).name || "";
        }
      },
      {
        field: "LimiteDiarioKm",
        headerText: "Limite Diário (Km)",
        type: "number",
        allowSorting: true,
        visible: false,
      },
      {
        field: "MedidorInicial",
        headerText: "Medidor Inicial",
        type: "number",
        allowSorting: true,
        visible: false,
      },
      {
        field: "TipoCombustivelDesc",
        headerText: "Tipo de Combustível",
        type: "string",
        allowSorting: true,
        valueAccessor: (_field: string, _data: any): any => {
          return this.listaTipoCombustivel.find(item => item.value === _data.TipoCombustivel).name || "";
        }
      },
      {
        field: "ValorAquisicao",
        headerText: "Valor de Aquisição",
        type: "number",
        allowSorting: true,
        visible: false,
      },
      {
        field: "ValorResidual",
        headerText: "Valor Residual",
        type: "number",
        allowSorting: true,
        visible: false,
      },
      {
        field: "VidaUtilHoras",
        headerText: "Vida Útil",
        type: "number",
        allowSorting: true,
      },
      {
        field: "DataAlteracaoFilter",
        headerText: "Ult. Mod.",
        type: "date",
        allowSorting: true,
        format: "dd/MM/yyyy HH:mm",
        filter: {
          type: 'Menu'
        },
        valueAccessor: (_field: string, _data: any): any => {
          // Exibe o DataAlteracao original (com hora) mas filtra pelo DataAlteracaoFilter (sem hora)
          if (_data.DataAlteracao) {
            const date = _data.DataAlteracao instanceof Date 
              ? _data.DataAlteracao 
              : new Date(_data.DataAlteracao);
            return isNaN(date.getTime()) ? null : date;
          }
          return null;
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "AtivoDesc",
        headerText: "Status",
        type: "boolean",
        allowSorting: true,
        disableHtmlEncode: false,
        filter: {
          type: 'Menu'
        },
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      },
    ]
    this.ajustarTamanhoGrid();
  }
  doubleClick(event): void {
    this.editar(event.Id)
  }
  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }
  selecionarEquipamento() {
    this.carregando = true;
    this.equipamentosService.getEquipamento(this.id).subscribe(res => {
      this.equipamento = new Equipamento();
      this.equipamento = res;
      this.carregando = false;
    },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      })
  }

  listarEquipamentos() {
    this.carregando = true;
    if (this.gridEquipamentos)
      this.gridEquipamentos.showSpinner()
    this.equipamentosService.getTodosEquipamentos().subscribe(
      res => {
        // Adiciona campo virtual com a descrição do tipo de combustível para filtragem
        res.forEach(equipamento => {
          const tipoCombustivel = this.listaTipoCombustivel.find(item => item.value === equipamento.TipoCombustivel);
          equipamento['TipoCombustivelDesc'] = tipoCombustivel ? tipoCombustivel.name : '';
          equipamento['AtivoDesc'] = equipamento.Ativo ? 'Ativo' : 'Inativo';
          // Converte DataAlteracao para Date se for string ou se não for Date
          if (equipamento.DataAlteracao) {
            try {
              let dateValue: Date;
              if (typeof equipamento.DataAlteracao === 'string') {
                // Tenta parsear a string de data
                dateValue = new Date(equipamento.DataAlteracao);
                // Se falhar, tenta usar moment para parsear
                if (isNaN(dateValue.getTime())) {
                  const momentDate = moment(equipamento.DataAlteracao);
                  if (momentDate.isValid()) {
                    dateValue = momentDate.toDate();
                  } else {
                    dateValue = null;
                  }
                }
              } else if (equipamento.DataAlteracao instanceof Date) {
                dateValue = equipamento.DataAlteracao;
              } else {
                dateValue = new Date(equipamento.DataAlteracao);
              }
              
              // Verifica se a data é válida
              if (dateValue && !isNaN(dateValue.getTime())) {
                equipamento.DataAlteracao = dateValue;
                // Cria campo auxiliar para filtragem (data normalizada para meia-noite)
                // Isso ajuda o filtro a encontrar datas mesmo quando há hora diferente
                const normalizedDate = new Date(dateValue);
                normalizedDate.setHours(0, 0, 0, 0);
                equipamento['DataAlteracaoFilter'] = normalizedDate;
              } else {
                equipamento.DataAlteracao = null;
                equipamento['DataAlteracaoFilter'] = null;
              }
            } catch (error) {
              console.warn('Erro ao converter DataAlteracao:', error, equipamento.DataAlteracao);
              equipamento.DataAlteracao = null;
              equipamento['DataAlteracaoFilter'] = null;
            }
          } else {
            equipamento['DataAlteracaoFilter'] = null;
          }
        });
        
        this.equipamentos = res;
        this.auxEquipamentos = res;
        this.carregando = false;
        if (this.gridEquipamentos)
          this.gridEquipamentos.hideSpinner()
        if (this.textoBusca != '')
          this.filtrarEquipamentos();

        if (!this.inserindo)
          this.configurarGrid();
      },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
        if (this.gridEquipamentos)
          this.gridEquipamentos.hideSpinner()
      });
  }

  novo(): void {
    if (!this.utils.verificarPermissaoUsuario('IncluirEquipamento'))
      return;
    this.router.navigate(['/cadastros/equipamento/inserir']);
  }

  editar(id: number = 0): void {
    if (!this.utils.verificarPermissaoUsuario('EditarEquipamento'))
      return;

    if (id == 0) {
      var variedades = this.gridEquipamentos.getSelectedRecords();
      if (!this.ValidarSelectApenasUm()) return

      id = variedades[0].Id
    }
    this.router.navigate(['/cadastros/equipamento/' + id]);
  }

  save(form: any) {
    if (!form.valid || this.equipamento.VidaUtilHoras <= 0) {
      this.isSubmit = true;
      this.toasty.show('Erro!', 'Preencha todos os campos corretamente!', 'warning');
      return;
    }

    this.carregando = true;
    this.equipamento.TipoMedidor = Number.parseInt(this.equipamento.TipoMedidor.toString());

    if (this.equipamento.Id > 0)
      this.equipamentosService.putEquipamento(this.equipamento.Id, this.equipamento).subscribe(
        res => {
          this.toasty.show('Feito!', 'Equipamento alterado!', 'success');
          this.selecionarEquipamento();
          this.carregando = false;
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
    else
      this.equipamentosService.postEquipamento(this.equipamento).subscribe(
        res => {
          this.toasty.show('Feito!', 'Equipamento cadastrado!', 'success');
          this.carregando = false;
          this.listarEquipamentos();
          this.cancelar();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });

  }

  excluir(grupooperacaoId: number, nome: string) {
    if (!this.utils.verificarPermissaoUsuario('ExcluirEquipamento'))
      return;
    Swal.fire({
      title: 'Deletar ' + nome + '?',
      text: 'Se deletar, esta ação não poderá ser desfeita!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim',
    }).then((willDelete) => {
      if (willDelete.dismiss) {

      } else {
        this.carregando = true;
        this.equipamentosService.deleteEquipamento(grupooperacaoId).subscribe(
          res => {
            this.toasty.show('Feito!', 'Equipamento deletado!', 'success');
            this.listarEquipamentos();
            this.carregando = false;
          },
          err => {
            this.utils.getErro(err);
            this.carregando = false;
          });
      }
    });
  }

  filtrarEquipamentos() {
    this.equipamentos = this.auxEquipamentos.filter(x =>
      x.Descricao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
    );
  }

  cancelar() {
    this.router.navigate(['/cadastros/equipamento']);
  }

  getGrupoEquipamento(id: number): GrupoEquipamento {
    if (!this.grupoEquipamentos)
      return null;

    let grupoEquipamento = this.grupoEquipamentos.filter(x =>
      x.Id == id
    );

    return grupoEquipamento.length > 0 ? grupoEquipamento[0] : new GrupoEquipamento();
  }

  getBase64(event) {
    let that = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      that.equipamento.IconeIrrigaPrimeBase64 = reader.result.toString();
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  prepararListaProcesso(selecionados: any) {
    this.equipamento._processoPlanejamento = selecionados.map(x => x.value.Id);
    this.equipamento.ProcessoPlanejamento = selecionados.map(x => x.value.Id).join(",");
  }

  confirmRemover() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirEquipamento'))
      return;


    var equipamentos = this.gridEquipamentos.getSelectedRecords();
    if (equipamentos.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: 'Se deletar, esta ação não poderá ser desfeita!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim',
    }).then((willDelete) => {
      if (!willDelete.dismiss)
        this.removerEquipamentos(equipamentos)
    });
  }

  removerEquipamentos(equipamentos: Equipamento[]) {
    this.removendo = true;
    this.equipamentosService.deleteEquipamentos(equipamentos.map(e => e.Id)).subscribe(
      res => {

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais equipamentos falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const equipamento = equipamentos.find(v => v.Id.toString() === id);
            const nomeEquipamento = equipamento ? equipamento.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeEquipamento}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir equipamentos',
            html: `Os seguintes equipamentos não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os equipamentos foram excluídos
          this.utils.handleSuccess("Equipamentos excluídos com sucesso");
        }

        this.listarEquipamentos();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
      });


  }

  confirmaDuplicar(): void {
    var equipamentos = this.gridEquipamentos.getSelectedRecords();
    if (!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os equipamentos selecionados serão duplicados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar equipamentos",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(equipamentos);
      }
    });
  }

  duplicar(equipamentos: Equipamento[]): void {
    this.duplicando = true
    this.equipamentosService.duplicar(equipamentos.map(p => p.Id))
      .subscribe(() => {
        this.utils.handleSuccess("Equipamentos duplicados com sucesso")
        this.listarEquipamentos();
        this.duplicando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.duplicando = false
        }
      )
  }

  ValidarSelectApenasUm(): boolean {
    var equipamentos = this.gridEquipamentos.getSelectedRecords();
    if (equipamentos.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if (equipamentos.length > 1) {
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }

  ValidarSelectUmOuMais(): boolean {
    var equipamentos = this.gridEquipamentos.getSelectedRecords();
    if (equipamentos.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  confirmaInativar(): void {
    if (!this.ValidarSelectUmOuMais()) return
    var equipamentos = this.gridEquipamentos.getSelectedRecords();
    if (equipamentos.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os equipamentos selecionados serão inativados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar equipamentos",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(equipamentos);
      }
    });

  }

  inativar(equipamentos: Equipamento[]): void {
    this.inativando = true
    this.equipamentosService.inativar(equipamentos.map(p => p.Id))
      .subscribe((res) => {
        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais equipamentos falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const equipamento = equipamentos.find(v => v.Id.toString() === id);
            const nomeEquipamento = equipamento ? equipamento.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeEquipamento}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao inativar equipamentos',
            html: `Os seguintes equipamentos não puderam ser inativados:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todos os equipamentos foram inativados
          this.utils.handleSuccess("Equipamentos inativados com sucesso");
        }
        this.listarEquipamentos();
        this.inativando = false
      },
        (err) => {
          this.utils.getErro(err)
          this.inativando = false
        }
      )
  }

}
